import arrayMutators from 'final-form-arrays';
import { func } from 'prop-types';
import React from 'react';
import { Form as FinalForm } from 'react-final-form';
// These relative imports need to point to correct directories
import congratulationImage from '../../assets/images/congratulation.png';
import { Button, FieldCheckbox, FieldRadioButton, Form, ResponsiveImage } from '../../components';
import {
  FormattedMessage,
  intlShape
} from '../../util/reactIntl';
import css from "./MerchantDetails.module.css";

const CongratulationsForm = props => {
  return (
    <FinalForm
      {...props}
      mutators={{
        ...arrayMutators,
      }}
      render={formRenderProps => {
        const {
          disabled,
          handleSubmit,
          intl,
          invalid,
          pristine,
          updated,
          formId,
          updateError,
          updateInProgress,
          values,
          form,
          successToaster,
          errorToaster,
          currentUser,
        } = formRenderProps;

        const { usingNowFor } = values;

        const errorMessage = updateError ? (
          <p className={css.error}>
            <FormattedMessage id="ProfileSettingsForm.updateProfileFailed" />
          </p>
        ) : null;

        const submitReady = updated && pristine;
        const submitInProgress = updateInProgress;
        const submitDisabled = invalid || disabled || submitInProgress || !usingNowFor;

        const profileDetail = [
          {
            heading: intl.formatMessage({ id: "CustomiseProfile.profileDetail.reduceHeading" }),
            subHeading: intl.formatMessage({ id: "CustomiseProfile.profileDetail.reduceSubHeading" }),
            value: "reduceIdleCapacity",
          },
          {
            heading: intl.formatMessage({ id: "CustomiseProfile.profileDetail.sellHeading" }),
            subHeading: intl.formatMessage({ id: "CustomiseProfile.profileDetail.sellSubHeading" }),
            value: "sellInventory",
          },
          {
            heading: intl.formatMessage({ id: "CustomiseProfile.profileDetail.manageHeading" }),
            subHeading: intl.formatMessage({ id: "CustomiseProfile.profileDetail.manageSubHeading" }),
            value: "manageOperations",
          },
        ]

        const congratulationIcon = (
          <ResponsiveImage
            localImageSrc={congratulationImage}
            alt='congratulation Image'
            variants="custom-image" />
        );

        return (
          <Form onSubmit={handleSubmit} className={css.mainForm}>
            <div className={css.inputBox}>
              <div className={css.customiseProfile}>
                <div className={css.customiseWrapper}>
                  <div className={css.innerBox}>
                    <div className={css.profileHeading}>
                      <FormattedMessage id="CongratulationsForm.heading" values={{ icon: congratulationIcon }} />
                    </div>
                    <div className={css.profileSubHeading}>
                      <FormattedMessage id="CongratulationsForm.subHeading" />
                    </div>
                    <div className={css.bottomContent}>

                      <div className={css.profileBox}>
                        {profileDetail.map((item, i) => {
                          const itemLabel = (<div className={css.rightDetail}>
                            <div className={css.listWrapper}>
                              <div className={css.mainHeading}>{item.heading}</div>
                              <div className={css.mainSubHeading}>{item.subHeading}</div>
                            </div>
                          </div>);
                          return (
                            <div className={css.checkList} key={i}>
                              <div className={css.checkbox}>
                                {/* <FieldRadioButton
                                  type="radio"
                                  id={`usingNowFor${i + 1}`}
                                  name="usingNowFor"
                                  label={itemLabel}
                                  value={item?.value}
                                  showAsRequired={true}
                                  customSvg
                                /> */}

                                <FieldCheckbox
                                  className={css.checkWrapper}
                                  id={`usingNowFor${i + 1}`}
                                  name="usingNowFor"
                                  label={itemLabel}
                                  value={item?.value}
                                  showAsRequired={true}
                                  customSvg
                                />
                              </div>
                            </div>
                          )
                        })}

                        {errorMessage ? errorMessage : null}

                        <div className={css.dealButton}>
                          {/* <NamedLink
                            name="MerchantOnboardingPage"
                            className={css.createNewListingLink}
                          > */}
                          <Button
                            type="submit"
                            className={css.button}
                            inProgress={submitInProgress}
                            disabled={submitDisabled}
                            ready={submitReady}
                          >
                            <FormattedMessage id="CustomiseProfile.createNewListingLink" />
                          </Button>
                          {/* </NamedLink> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        );
      }}
    />
  )
}

CongratulationsForm.defaultProps = {
  selectedPlace: null,
  updateError: null,
};

CongratulationsForm.propTypes = {
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  //   updateInProgress: bool.isRequired,
};

export default CongratulationsForm;